import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { applyRTLStyles } from '../utils/rtlSupport';

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Apply RTL/LTR styles whenever language changes
    applyRTLStyles(i18n.language);
  }, [i18n.language]);

  return <>{children}</>;
};

export default LanguageProvider;